const envSettings = window as any;
export class Config {
  static api_core_url = envSettings.API_CORE_URL;
  static auth0_domain = envSettings.AUTH0_DOMAIN;
  static auth0_clientId = envSettings.AUTH0_CLIENT_ID;
  static auth0_redirectUrl = envSettings.AUTH0_CALLBACK_URL;
  static auth0_audience = envSettings.AUTH0_AUDIENCE;
  static mapbox_accesstoken = envSettings.MAPBOX_ACCESSTOKEN;
}
